<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()" *ngIf="records">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ lang?.generalData }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
     <table class="table table-striped table-hover table-bordered" >
        <tbody>
          <tr>           
            <td width="30%">{{ lang.code }}</td>
            <td>{{ records.doc_code }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.title }}</td>
            <td>{{ records.doc_title }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.documentType }}</td>
            <td>{{ records.doc_type }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.origin }}</td>
            <td>{{ records.doc_origin }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.revision }}</td>
            <td>{{ records.revision }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.revisionDate }}</td>
            <td>{{ records.revision_date }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.expiryDate }}</td>
            <td>{{ records.expiry_date }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.daysleft }}</td>
            <td>{{ records.days_left }}</td>
          </tr>

        </tbody>
      </table>

  </div>

</form>
